import { Input, Alert } from "antd";
import "antd/dist/antd.css";
import { useEffect, useState } from "react";
import { Circle } from "./components/circle";
import { Logo } from "./components/logo";
import { UserHuntTabs } from "./components/tabs";

export interface Sites {
  [key: string]: [string];
}

const validateUsername = (username: string) => {
  let re = new RegExp(/[a-zA-Z0-9.]/gi);
  const matches = username.match(re) || [];
  return matches.length === username.length;
};

const App = () => {
  const baseUrl = "https://sherlock-java-http.herokuapp.com";
  const [username, setUsername] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [sites, setSites] = useState<[Sites] | undefined>(undefined);
  const [checkedSites, setCheckedSites] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedSites, setSelectedSites] = useState<Array<string>>([
    "Twitter",
    "Facebook",
    "9GAG",
    "AllTrails",
    "AskFM",
    "VK",
  ]);

  const fetchMappingSites = async () => {
    const endpoint = `${baseUrl}/sherlock/api/v1/sites/mapping`;
    const response = await fetch(endpoint);
    const data = await response.json();
    setSites(data);
  };

  const onSelectAll = (category: keyof Sites, isSelecting: boolean) => {
    if (sites) {
      const allSitesInCategory = sites[category as number] as any;
      const data = isSelecting
        ? [...selectedSites, ...allSitesInCategory]
        : selectedSites.filter((each) => {
            return !allSitesInCategory.includes(each);
          });
      setSelectedSites(data as any);
    }
  };

  const onSelect = (val: any, isChecked: boolean) => {
    const data = isChecked
      ? [...selectedSites, val]
      : selectedSites.filter((each) => each !== val);
    setSelectedSites(data as any);
  };

  const onSearch = async () => {
    setIsLoading(true);
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    const endpoint = `${baseUrl}/sherlock/api/v1/execute/${username}`;
    const response = await fetch(endpoint, {
      headers,
      method: "POST",
      body: JSON.stringify(selectedSites),
      redirect: "follow",
    });
    const data = await response.text();

    setIsLoading(false);
    setCheckedSites(JSON.parse(data));
  };

  useEffect(() => {
    fetchMappingSites();
  }, []);

  const searchButton = (
    <button
      onClick={onSearch}
      disabled={
        username.length === 0 ||
        selectedSites.length === 0 ||
        isLoading ||
        !isValid
      }
    >
      {isLoading ? "Loading..." : "Search"}
    </button>
  );

  return (
    <div>
      <header>
        <Logo />
        <h1>UserHunt</h1>
      </header>
      <main>
        <Circle />
        <div className="banner">
          <h2>
            Hunt Down
            <br />
            Social Media Accounts
            <span>by username across social networks.</span>
          </h2>
          <div className="banner_background">
            <div className="banner_background_logos">
              <img src="./Logo_1.png" alt="logo_1" />
              <img src="./Logo_2.png" alt="logo_2" />
              <img src="./Logo_3.png" alt="logo_3" />
              <img src="./Logo_4.png" alt="logo_4" />
              <img src="./Logo_5.png" alt="logo_5" />
              <img src="./Logo_6.png" alt="logo_6" />
              <img src="./Logo_7.png" alt="logo_7" />
            </div>
          </div>
        </div>
        <div className="input_wrapper">
          <Input
            placeholder="Enter username to search"
            allowClear
            size="large"
            addonAfter={searchButton}
            value={username}
            onChange={(event) => {
              const val = event.target.value;
              const isValid = validateUsername(val);
              setIsValid(isValid);
              setUsername(val);
            }}
          />
        </div>
        <div className="alert_wrapper">
          {!isValid && (
            <Alert
              message="Usernames can only contain letters (a-z), numbers (0-9), and periods (.)."
              showIcon
              type="error"
            />
          )}
          {selectedSites.length === 0 && (
            <Alert
              message="Please select atleast one website from the below list"
              showIcon
              type="warning"
            />
          )}
          {sites && Object.keys(sites as any).length === 0 && (
            <Alert
              message="Usernames can only contain letters (a-z), numbers (0-9), and periods (.)."
              showIcon
              type="error"
            />
          )}
        </div>
        <div className="tabs_wrapper">
          {sites && (
            <UserHuntTabs
              sites={sites}
              onSelect={onSelect}
              onSelectAll={onSelectAll}
              selectedSites={selectedSites as [string]}
              checkedSites={checkedSites}
            />
          )}
        </div>
      </main>
      <footer className="footer">
        <div>
        MIT &copy; Built using <a href="https://github.com/sherlock-project/sherlock" target="_blank" rel="noreferrer">Sherlock.</a> By <a href="https://twitter.com/sagarpatil" target="_blank" rel="noreferrer">@Sagar</a> and <a href="https://twitter.com/techie_lfc" target="_blank" rel="noreferrer">@Virendra</a>
        </div>
      </footer>
    </div>
  );
};

export default App;
